<template>
    <div style="position: relative;">
      <span v-if="String(text).length > 13">
        <v-tooltip location='top'>
          <template v-slot:activator="{ props}">
            <span v-bind="props" @dblclick="copyText" class="no-select" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; position: relative;">
              {{ String(text).substring(0, 13) }}...
              <div v-if="showCopiedTooltip" class="copied-tooltip">
                Copied!
              </div>
            </span>
          </template>
          <span style="max-width: 700px; word-wrap: break-word; white-space: normal;">
            {{ text }}
          </span>
        </v-tooltip>
      </span>
      <span v-else @dblclick="copyText" class="no-select" style="white-space: normal; position: relative;">
        {{ text }}
        <div v-if="showCopiedTooltip" class="copied-tooltip">
          Copied!
        </div>
      </span>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      text: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        showCopiedTooltip: false,
      };
    },
    methods: {
      copyText() {
        navigator.clipboard.writeText(String(this.text)).then(() => {
          this.showCopiedTooltip = true;
          setTimeout(() => {
            this.showCopiedTooltip = false;
          }, 1000);
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .copied-tooltip {
    position: absolute;
    background-color: #555;
    color: #fff;
    padding: 5px;
    border-radius: 3px;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 5px;
    z-index: 1000;
  }
  .no-select {
    user-select: none;
  }
  </style>